import React, {useMemo} from "react"
import PropTypes from "prop-types"

import DataGridTable from "src/v2/components/Table/data-grid-table"
import { getColumnsTableEmissao  } from "./emission-table-const"

const EmissionTable = ({
    data = [],
    loading = false,
    isAdminUser = false,
}) => {

    const columns = useMemo(
        () => getColumnsTableEmissao(isAdminUser),
        [isAdminUser]
    )

    return (
        <DataGridTable
            rows={data}
            columns={columns}
            loading={loading}
            disableDeleteColumn
            pageSize={25}
            getRowId={(row) =>
                row.CETIP ??
                `${row.ISIN}-${row.DataEmissao}`
            }
        />
    )
}

EmissionTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.object
    ).isRequired,
    loading: PropTypes.bool,
    isAdminUser: PropTypes.bool,
}

export default EmissionTable